/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
let domain = ''
export const getDomain = () => {
  return domain
}
export const setDomain = $domain => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase()
  let keys = Object.keys(queryParameters)
  let queryUrl = url
  if (keys.length > 0) {
    queryUrl = url + '?' + qs.stringify(queryParameters)
  }
  // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
  if (body) {
    if (method === 'delete') {
      return axios[method](
        queryUrl,
        {
          data: body,
        },
        config,
      )
    }
    return axios[method](queryUrl, body, config)
  } else if (method === 'get') {
    return axios[method](
      queryUrl,
      {
        params: form,
      },
      config,
    )
  } else {
    return axios[method](queryUrl, qs.stringify(form), config)
  }
}
/*==========================================================
 *                    
 ==========================================================*/
/**
 *
 * request: Account_Register
 * url: Account_RegisterURL
 * method: Account_Register_TYPE
 * raw_url: Account_Register_RAW_URL
 * @param req -
 */
export const Account_Register = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/account/register'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['req'] !== undefined) {
    body = parameters['req']
  }
  if (parameters['req'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: req'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Account_Register_RAW_URL = function() {
  return '/api/account/register'
}
export const Account_Register_TYPE = function() {
  return 'post'
}
export const Account_RegisterURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/account/register'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Account_PasswordForgotten
 * url: Account_PasswordForgottenURL
 * method: Account_PasswordForgotten_TYPE
 * raw_url: Account_PasswordForgotten_RAW_URL
 * @param cmd -
 */
export const Account_PasswordForgotten = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/account/reset-password'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Account_PasswordForgotten_RAW_URL = function() {
  return '/api/account/reset-password'
}
export const Account_PasswordForgotten_TYPE = function() {
  return 'put'
}
export const Account_PasswordForgottenURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/account/reset-password'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Account_PasswordForgotten2
 * url: Account_PasswordForgotten2URL
 * method: Account_PasswordForgotten2_TYPE
 * raw_url: Account_PasswordForgotten2_RAW_URL
 * @param cmd -
 */
export const Account_PasswordForgotten2 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/account/password-forgotten'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Account_PasswordForgotten2_RAW_URL = function() {
  return '/api/account/password-forgotten'
}
export const Account_PasswordForgotten2_TYPE = function() {
  return 'post'
}
export const Account_PasswordForgotten2URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/account/password-forgotten'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Account_ChangePassword
 * url: Account_ChangePasswordURL
 * method: Account_ChangePassword_TYPE
 * raw_url: Account_ChangePassword_RAW_URL
 * @param req -
 */
export const Account_ChangePassword = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/account/change-password'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['req'] !== undefined) {
    body = parameters['req']
  }
  if (parameters['req'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: req'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Account_ChangePassword_RAW_URL = function() {
  return '/api/account/change-password'
}
export const Account_ChangePassword_TYPE = function() {
  return 'put'
}
export const Account_ChangePasswordURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/account/change-password'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Account_GetUserData
 * url: Account_GetUserDataURL
 * method: Account_GetUserData_TYPE
 * raw_url: Account_GetUserData_RAW_URL
 */
export const Account_GetUserData = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/account/me'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Account_GetUserData_RAW_URL = function() {
  return '/api/account/me'
}
export const Account_GetUserData_TYPE = function() {
  return 'get'
}
export const Account_GetUserDataURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/account/me'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Account_UpdateUserData
 * url: Account_UpdateUserDataURL
 * method: Account_UpdateUserData_TYPE
 * raw_url: Account_UpdateUserData_RAW_URL
 * @param userData -
 */
export const Account_UpdateUserData = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/account/me'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['userData'] !== undefined) {
    body = parameters['userData']
  }
  if (parameters['userData'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userData'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Account_UpdateUserData_RAW_URL = function() {
  return '/api/account/me'
}
export const Account_UpdateUserData_TYPE = function() {
  return 'put'
}
export const Account_UpdateUserDataURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/account/me'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Auth_Login
 * url: Auth_LoginURL
 * method: Auth_Login_TYPE
 * raw_url: Auth_Login_RAW_URL
 * @param cmd -
 */
export const Auth_Login = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/auth/login'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Auth_Login_RAW_URL = function() {
  return '/api/auth/login'
}
export const Auth_Login_TYPE = function() {
  return 'post'
}
export const Auth_LoginURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/auth/login'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Auth_Refresh
 * url: Auth_RefreshURL
 * method: Auth_Refresh_TYPE
 * raw_url: Auth_Refresh_RAW_URL
 * @param cmd -
 */
export const Auth_Refresh = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/auth/connect/refresh'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Auth_Refresh_RAW_URL = function() {
  return '/api/auth/connect/refresh'
}
export const Auth_Refresh_TYPE = function() {
  return 'post'
}
export const Auth_RefreshURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/auth/connect/refresh'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Debug_SendTestEmail
 * url: Debug_SendTestEmailURL
 * method: Debug_SendTestEmail_TYPE
 * raw_url: Debug_SendTestEmail_RAW_URL
 * @param pathToTemplate -
 * @param toEmail -
 * @param isWire -
 * @param isPaid -
 */
export const Debug_SendTestEmail = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/debug'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['pathToTemplate'] !== undefined) {
    queryParameters['pathToTemplate'] = parameters['pathToTemplate']
  }
  if (parameters['toEmail'] !== undefined) {
    queryParameters['toEmail'] = parameters['toEmail']
  }
  if (parameters['isWire'] !== undefined) {
    queryParameters['isWire'] = parameters['isWire']
  }
  if (parameters['isPaid'] !== undefined) {
    queryParameters['isPaid'] = parameters['isPaid']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Debug_SendTestEmail_RAW_URL = function() {
  return '/api/debug'
}
export const Debug_SendTestEmail_TYPE = function() {
  return 'get'
}
export const Debug_SendTestEmailURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/debug'
  if (parameters['pathToTemplate'] !== undefined) {
    queryParameters['pathToTemplate'] = parameters['pathToTemplate']
  }
  if (parameters['toEmail'] !== undefined) {
    queryParameters['toEmail'] = parameters['toEmail']
  }
  if (parameters['isWire'] !== undefined) {
    queryParameters['isWire'] = parameters['isWire']
  }
  if (parameters['isPaid'] !== undefined) {
    queryParameters['isPaid'] = parameters['isPaid']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Guard_VerifyAlphaNumericGuard
 * url: Guard_VerifyAlphaNumericGuardURL
 * method: Guard_VerifyAlphaNumericGuard_TYPE
 * raw_url: Guard_VerifyAlphaNumericGuard_RAW_URL
 * @param req -
 */
export const Guard_VerifyAlphaNumericGuard = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/guard/number'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['req'] !== undefined) {
    body = parameters['req']
  }
  if (parameters['req'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: req'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Guard_VerifyAlphaNumericGuard_RAW_URL = function() {
  return '/api/guard/number'
}
export const Guard_VerifyAlphaNumericGuard_TYPE = function() {
  return 'post'
}
export const Guard_VerifyAlphaNumericGuardURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/guard/number'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Hotel_AllOffers
 * url: Hotel_AllOffersURL
 * method: Hotel_AllOffers_TYPE
 * raw_url: Hotel_AllOffers_RAW_URL
 */
export const Hotel_AllOffers = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/hotel/for-map'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Hotel_AllOffers_RAW_URL = function() {
  return '/api/hotel/for-map'
}
export const Hotel_AllOffers_TYPE = function() {
  return 'get'
}
export const Hotel_AllOffersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/hotel/for-map'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Hotel_CloseTo
 * url: Hotel_CloseToURL
 * method: Hotel_CloseTo_TYPE
 * raw_url: Hotel_CloseTo_RAW_URL
 * @param latitude -
 * @param longitude -
 * @param radius -
 */
export const Hotel_CloseTo = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/hotel/close-to'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['latitude'] !== undefined) {
    queryParameters['latitude'] = parameters['latitude']
  }
  if (parameters['longitude'] !== undefined) {
    queryParameters['longitude'] = parameters['longitude']
  }
  if (parameters['radius'] !== undefined) {
    queryParameters['radius'] = parameters['radius']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Hotel_CloseTo_RAW_URL = function() {
  return '/api/hotel/close-to'
}
export const Hotel_CloseTo_TYPE = function() {
  return 'get'
}
export const Hotel_CloseToURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/hotel/close-to'
  if (parameters['latitude'] !== undefined) {
    queryParameters['latitude'] = parameters['latitude']
  }
  if (parameters['longitude'] !== undefined) {
    queryParameters['longitude'] = parameters['longitude']
  }
  if (parameters['radius'] !== undefined) {
    queryParameters['radius'] = parameters['radius']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Hotel_BoundingBox
 * url: Hotel_BoundingBoxURL
 * method: Hotel_BoundingBox_TYPE
 * raw_url: Hotel_BoundingBox_RAW_URL
 * @param latitudeTop -
 * @param longitudeTop -
 * @param latitudeBottom -
 * @param longitudeBottom -
 */
export const Hotel_BoundingBox = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/hotel/bounding-box'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['latitudeTop'] !== undefined) {
    queryParameters['latitudeTop'] = parameters['latitudeTop']
  }
  if (parameters['longitudeTop'] !== undefined) {
    queryParameters['longitudeTop'] = parameters['longitudeTop']
  }
  if (parameters['latitudeBottom'] !== undefined) {
    queryParameters['latitudeBottom'] = parameters['latitudeBottom']
  }
  if (parameters['longitudeBottom'] !== undefined) {
    queryParameters['longitudeBottom'] = parameters['longitudeBottom']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Hotel_BoundingBox_RAW_URL = function() {
  return '/api/hotel/bounding-box'
}
export const Hotel_BoundingBox_TYPE = function() {
  return 'get'
}
export const Hotel_BoundingBoxURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/hotel/bounding-box'
  if (parameters['latitudeTop'] !== undefined) {
    queryParameters['latitudeTop'] = parameters['latitudeTop']
  }
  if (parameters['longitudeTop'] !== undefined) {
    queryParameters['longitudeTop'] = parameters['longitudeTop']
  }
  if (parameters['latitudeBottom'] !== undefined) {
    queryParameters['latitudeBottom'] = parameters['latitudeBottom']
  }
  if (parameters['longitudeBottom'] !== undefined) {
    queryParameters['longitudeBottom'] = parameters['longitudeBottom']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Hotel_List
 * url: Hotel_ListURL
 * method: Hotel_List_TYPE
 * raw_url: Hotel_List_RAW_URL
 * @param page -
 * @param pageSize -
 */
export const Hotel_List = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/hotel/list/{page}/{pageSize}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{page}', `${parameters['page']}`)
  if (parameters['page'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: page'))
  }
  path = path.replace('{pageSize}', `${parameters['pageSize']}`)
  if (parameters['pageSize'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pageSize'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Hotel_List_RAW_URL = function() {
  return '/api/hotel/list/{page}/{pageSize}'
}
export const Hotel_List_TYPE = function() {
  return 'get'
}
export const Hotel_ListURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/hotel/list/{page}/{pageSize}'
  path = path.replace('{page}', `${parameters['page']}`)
  path = path.replace('{pageSize}', `${parameters['pageSize']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Hotel_Hotel
 * url: Hotel_HotelURL
 * method: Hotel_Hotel_TYPE
 * raw_url: Hotel_Hotel_RAW_URL
 * @param slug -
 */
export const Hotel_Hotel = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/hotel/{slug}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{slug}', `${parameters['slug']}`)
  if (parameters['slug'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: slug'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Hotel_Hotel_RAW_URL = function() {
  return '/api/hotel/{slug}'
}
export const Hotel_Hotel_TYPE = function() {
  return 'get'
}
export const Hotel_HotelURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/hotel/{slug}'
  path = path.replace('{slug}', `${parameters['slug']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Insurance_BookInsurance
 * url: Insurance_BookInsuranceURL
 * method: Insurance_BookInsurance_TYPE
 * raw_url: Insurance_BookInsurance_RAW_URL
 * @param cmd -
 */
export const Insurance_BookInsurance = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/insurance/book'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Insurance_BookInsurance_RAW_URL = function() {
  return '/api/insurance/book'
}
export const Insurance_BookInsurance_TYPE = function() {
  return 'post'
}
export const Insurance_BookInsuranceURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/insurance/book'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Invoice_DownloadInvoice
 * url: Invoice_DownloadInvoiceURL
 * method: Invoice_DownloadInvoice_TYPE
 * raw_url: Invoice_DownloadInvoice_RAW_URL
 * @param id -
 * @param key -
 * @param invoiceNumber -
 */
export const Invoice_DownloadInvoice = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/invoice/download/{id}/{key}/{invoiceNumber}.pdf'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{invoiceNumber}', `${parameters['invoiceNumber']}`)
  if (parameters['invoiceNumber'] === undefined) {
    return Promise.reject(
      new Error('Missing required  parameter: invoiceNumber'),
    )
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Invoice_DownloadInvoice_RAW_URL = function() {
  return '/api/invoice/download/{id}/{key}/{invoiceNumber}.pdf'
}
export const Invoice_DownloadInvoice_TYPE = function() {
  return 'get'
}
export const Invoice_DownloadInvoiceURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/invoice/download/{id}/{key}/{invoiceNumber}.pdf'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{invoiceNumber}', `${parameters['invoiceNumber']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_Offer
 * url: Offer_OfferURL
 * method: Offer_Offer_TYPE
 * raw_url: Offer_Offer_RAW_URL
 * @param id -
 */
export const Offer_Offer = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_Offer_RAW_URL = function() {
  return '/api/offer'
}
export const Offer_Offer_TYPE = function() {
  return 'get'
}
export const Offer_OfferURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_OfferByVariantId
 * url: Offer_OfferByVariantIdURL
 * method: Offer_OfferByVariantId_TYPE
 * raw_url: Offer_OfferByVariantId_RAW_URL
 * @param id -
 */
export const Offer_OfferByVariantId = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/variant/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_OfferByVariantId_RAW_URL = function() {
  return '/api/offer/variant/{id}'
}
export const Offer_OfferByVariantId_TYPE = function() {
  return 'get'
}
export const Offer_OfferByVariantIdURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/variant/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_OfferBySlug
 * url: Offer_OfferBySlugURL
 * method: Offer_OfferBySlug_TYPE
 * raw_url: Offer_OfferBySlug_RAW_URL
 * @param slug -
 */
export const Offer_OfferBySlug = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/slug/{slug}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{slug}', `${parameters['slug']}`)
  if (parameters['slug'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: slug'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_OfferBySlug_RAW_URL = function() {
  return '/api/offer/slug/{slug}'
}
export const Offer_OfferBySlug_TYPE = function() {
  return 'get'
}
export const Offer_OfferBySlugURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/slug/{slug}'
  path = path.replace('{slug}', `${parameters['slug']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_OfferByContactSlug
 * url: Offer_OfferByContactSlugURL
 * method: Offer_OfferByContactSlug_TYPE
 * raw_url: Offer_OfferByContactSlug_RAW_URL
 * @param slug -
 * @param page -
 * @param pageSize -
 */
export const Offer_OfferByContactSlug = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/hotel/{slug}/{page}/{pageSize}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{slug}', `${parameters['slug']}`)
  if (parameters['slug'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: slug'))
  }
  path = path.replace('{page}', `${parameters['page']}`)
  if (parameters['page'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: page'))
  }
  path = path.replace('{pageSize}', `${parameters['pageSize']}`)
  if (parameters['pageSize'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pageSize'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_OfferByContactSlug_RAW_URL = function() {
  return '/api/offer/hotel/{slug}/{page}/{pageSize}'
}
export const Offer_OfferByContactSlug_TYPE = function() {
  return 'get'
}
export const Offer_OfferByContactSlugURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/hotel/{slug}/{page}/{pageSize}'
  path = path.replace('{slug}', `${parameters['slug']}`)
  path = path.replace('{page}', `${parameters['page']}`)
  path = path.replace('{pageSize}', `${parameters['pageSize']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_OfferData
 * url: Offer_OfferDataURL
 * method: Offer_OfferData_TYPE
 * raw_url: Offer_OfferData_RAW_URL
 * @param id -
 */
export const Offer_OfferData = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/data'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_OfferData_RAW_URL = function() {
  return '/api/offer/data'
}
export const Offer_OfferData_TYPE = function() {
  return 'get'
}
export const Offer_OfferDataURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/data'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_Search
 * url: Offer_SearchURL
 * method: Offer_Search_TYPE
 * raw_url: Offer_Search_RAW_URL
 * @param searchRequest -
 */
export const Offer_Search = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['searchRequest'] !== undefined) {
    body = parameters['searchRequest']
  }
  if (parameters['searchRequest'] === undefined) {
    return Promise.reject(
      new Error('Missing required  parameter: searchRequest'),
    )
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Offer_Search_RAW_URL = function() {
  return '/api/offer/search'
}
export const Offer_Search_TYPE = function() {
  return 'post'
}
export const Offer_SearchURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_TravelDeals
 * url: Offer_TravelDealsURL
 * method: Offer_TravelDeals_TYPE
 * raw_url: Offer_TravelDeals_RAW_URL
 */
export const Offer_TravelDeals = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/travel-deals'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_TravelDeals_RAW_URL = function() {
  return '/api/offer/travel-deals'
}
export const Offer_TravelDeals_TYPE = function() {
  return 'get'
}
export const Offer_TravelDealsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/travel-deals'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_Promotions
 * url: Offer_PromotionsURL
 * method: Offer_Promotions_TYPE
 * raw_url: Offer_Promotions_RAW_URL
 */
export const Offer_Promotions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/promotions'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_Promotions_RAW_URL = function() {
  return '/api/offer/promotions'
}
export const Offer_Promotions_TYPE = function() {
  return 'get'
}
export const Offer_PromotionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/promotions'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_Promotion
 * url: Offer_PromotionURL
 * method: Offer_Promotion_TYPE
 * raw_url: Offer_Promotion_RAW_URL
 * @param name -
 */
export const Offer_Promotion = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/promotion/{name}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters['name'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: name'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_Promotion_RAW_URL = function() {
  return '/api/offer/promotion/{name}'
}
export const Offer_Promotion_TYPE = function() {
  return 'get'
}
export const Offer_PromotionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/promotion/{name}'
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_Suggest
 * url: Offer_SuggestURL
 * method: Offer_Suggest_TYPE
 * raw_url: Offer_Suggest_RAW_URL
 * @param tag -
 */
export const Offer_Suggest = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/suggest/{tag}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tag}', `${parameters['tag']}`)
  if (parameters['tag'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tag'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_Suggest_RAW_URL = function() {
  return '/api/offer/suggest/{tag}'
}
export const Offer_Suggest_TYPE = function() {
  return 'get'
}
export const Offer_SuggestURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/suggest/{tag}'
  path = path.replace('{tag}', `${parameters['tag']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_GetAvailableThemes
 * url: Offer_GetAvailableThemesURL
 * method: Offer_GetAvailableThemes_TYPE
 * raw_url: Offer_GetAvailableThemes_RAW_URL
 */
export const Offer_GetAvailableThemes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/available-themes'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_GetAvailableThemes_RAW_URL = function() {
  return '/api/offer/available-themes'
}
export const Offer_GetAvailableThemes_TYPE = function() {
  return 'get'
}
export const Offer_GetAvailableThemesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/available-themes'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_GetAvailableCountries
 * url: Offer_GetAvailableCountriesURL
 * method: Offer_GetAvailableCountries_TYPE
 * raw_url: Offer_GetAvailableCountries_RAW_URL
 */
export const Offer_GetAvailableCountries = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/available-countries'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_GetAvailableCountries_RAW_URL = function() {
  return '/api/offer/available-countries'
}
export const Offer_GetAvailableCountries_TYPE = function() {
  return 'get'
}
export const Offer_GetAvailableCountriesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/available-countries'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_ListOffers
 * url: Offer_ListOffersURL
 * method: Offer_ListOffers_TYPE
 * raw_url: Offer_ListOffers_RAW_URL
 * @param page -
 * @param pageSize -
 * @param depth -
 */
export const Offer_ListOffers = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/list/{page}/{pageSize}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{page}', `${parameters['page']}`)
  if (parameters['page'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: page'))
  }
  path = path.replace('{pageSize}', `${parameters['pageSize']}`)
  if (parameters['pageSize'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pageSize'))
  }
  if (parameters['depth'] !== undefined) {
    queryParameters['depth'] = parameters['depth']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_ListOffers_RAW_URL = function() {
  return '/api/offer/list/{page}/{pageSize}'
}
export const Offer_ListOffers_TYPE = function() {
  return 'get'
}
export const Offer_ListOffersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/list/{page}/{pageSize}'
  path = path.replace('{page}', `${parameters['page']}`)
  path = path.replace('{pageSize}', `${parameters['pageSize']}`)
  if (parameters['depth'] !== undefined) {
    queryParameters['depth'] = parameters['depth']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_OfferGroup
 * url: Offer_OfferGroupURL
 * method: Offer_OfferGroup_TYPE
 * raw_url: Offer_OfferGroup_RAW_URL
 * @param name -
 * @param value -
 */
export const Offer_OfferGroup = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/group/{name}/{value}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters['name'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: name'))
  }
  path = path.replace('{value}', `${parameters['value']}`)
  if (parameters['value'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: value'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Offer_OfferGroup_RAW_URL = function() {
  return '/api/offer/group/{name}/{value}'
}
export const Offer_OfferGroup_TYPE = function() {
  return 'get'
}
export const Offer_OfferGroupURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/group/{name}/{value}'
  path = path.replace('{name}', `${parameters['name']}`)
  path = path.replace('{value}', `${parameters['value']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Offer_OfferGroups
 * url: Offer_OfferGroupsURL
 * method: Offer_OfferGroups_TYPE
 * raw_url: Offer_OfferGroups_RAW_URL
 * @param groups -
 */
export const Offer_OfferGroups = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/offer/groups'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['groups'] !== undefined) {
    body = parameters['groups']
  }
  if (parameters['groups'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: groups'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Offer_OfferGroups_RAW_URL = function() {
  return '/api/offer/groups'
}
export const Offer_OfferGroups_TYPE = function() {
  return 'post'
}
export const Offer_OfferGroupsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/offer/groups'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_Retrive
 * url: Order_RetriveURL
 * method: Order_Retrive_TYPE
 * raw_url: Order_Retrive_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_Retrive = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/{id}/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_Retrive_RAW_URL = function() {
  return '/api/order/{id}/{key}'
}
export const Order_Retrive_TYPE = function() {
  return 'get'
}
export const Order_RetriveURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/{id}/{key}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_MetaData
 * url: Order_MetaDataURL
 * method: Order_MetaData_TYPE
 * raw_url: Order_MetaData_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_MetaData = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/meta/{id}/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_MetaData_RAW_URL = function() {
  return '/api/order/meta/{id}/{key}'
}
export const Order_MetaData_TYPE = function() {
  return 'get'
}
export const Order_MetaDataURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/meta/{id}/{key}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_SelectedPayment
 * url: Order_SelectedPaymentURL
 * method: Order_SelectedPayment_TYPE
 * raw_url: Order_SelectedPayment_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_SelectedPayment = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/payment/{id}/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_SelectedPayment_RAW_URL = function() {
  return '/api/order/payment/{id}/{key}'
}
export const Order_SelectedPayment_TYPE = function() {
  return 'get'
}
export const Order_SelectedPaymentURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/payment/{id}/{key}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_Validate
 * url: Order_ValidateURL
 * method: Order_Validate_TYPE
 * raw_url: Order_Validate_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_Validate = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/validate/{id}/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_Validate_RAW_URL = function() {
  return '/api/order/validate/{id}/{key}'
}
export const Order_Validate_TYPE = function() {
  return 'get'
}
export const Order_ValidateURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/validate/{id}/{key}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_PrepareForCheckout
 * url: Order_PrepareForCheckoutURL
 * method: Order_PrepareForCheckout_TYPE
 * raw_url: Order_PrepareForCheckout_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_PrepareForCheckout = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/prepare/{id}/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_PrepareForCheckout_RAW_URL = function() {
  return '/api/order/prepare/{id}/{key}'
}
export const Order_PrepareForCheckout_TYPE = function() {
  return 'get'
}
export const Order_PrepareForCheckoutURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/prepare/{id}/{key}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_OrderNotifications
 * url: Order_OrderNotificationsURL
 * method: Order_OrderNotifications_TYPE
 * raw_url: Order_OrderNotifications_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_OrderNotifications = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/notifications/{id}/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_OrderNotifications_RAW_URL = function() {
  return '/api/order/notifications/{id}/{key}'
}
export const Order_OrderNotifications_TYPE = function() {
  return 'get'
}
export const Order_OrderNotificationsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/notifications/{id}/{key}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AvailableInsuranceUpgrades
 * url: Order_AvailableInsuranceUpgradesURL
 * method: Order_AvailableInsuranceUpgrades_TYPE
 * raw_url: Order_AvailableInsuranceUpgrades_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_AvailableInsuranceUpgrades = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/{id}/{key}/insurance-upgrades'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_AvailableInsuranceUpgrades_RAW_URL = function() {
  return '/api/order/{id}/{key}/insurance-upgrades'
}
export const Order_AvailableInsuranceUpgrades_TYPE = function() {
  return 'get'
}
export const Order_AvailableInsuranceUpgradesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/{id}/{key}/insurance-upgrades'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_Create
 * url: Order_CreateURL
 * method: Order_Create_TYPE
 * raw_url: Order_Create_RAW_URL
 * @param cmd -
 */
export const Order_Create = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_Create_RAW_URL = function() {
  return '/api/order'
}
export const Order_Create_TYPE = function() {
  return 'post'
}
export const Order_CreateURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AddArticle
 * url: Order_AddArticleURL
 * method: Order_AddArticle_TYPE
 * raw_url: Order_AddArticle_RAW_URL
 * @param cmd -
 */
export const Order_AddArticle = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/items'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_AddArticle_RAW_URL = function() {
  return '/api/order/items'
}
export const Order_AddArticle_TYPE = function() {
  return 'post'
}
export const Order_AddArticleURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/items'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_ChangeArticle
 * url: Order_ChangeArticleURL
 * method: Order_ChangeArticle_TYPE
 * raw_url: Order_ChangeArticle_RAW_URL
 * @param cmd -
 */
export const Order_ChangeArticle = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/items'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Order_ChangeArticle_RAW_URL = function() {
  return '/api/order/items'
}
export const Order_ChangeArticle_TYPE = function() {
  return 'put'
}
export const Order_ChangeArticleURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/items'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_RemoveArticle
 * url: Order_RemoveArticleURL
 * method: Order_RemoveArticle_TYPE
 * raw_url: Order_RemoveArticle_RAW_URL
 * @param cmd -
 */
export const Order_RemoveArticle = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/items'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Order_RemoveArticle_RAW_URL = function() {
  return '/api/order/items'
}
export const Order_RemoveArticle_TYPE = function() {
  return 'delete'
}
export const Order_RemoveArticleURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/items'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AddGiftCard
 * url: Order_AddGiftCardURL
 * method: Order_AddGiftCard_TYPE
 * raw_url: Order_AddGiftCard_RAW_URL
 * @param cmd -
 */
export const Order_AddGiftCard = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/giftcard'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_AddGiftCard_RAW_URL = function() {
  return '/api/order/giftcard'
}
export const Order_AddGiftCard_TYPE = function() {
  return 'post'
}
export const Order_AddGiftCardURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/giftcard'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_RemoveGiftCard
 * url: Order_RemoveGiftCardURL
 * method: Order_RemoveGiftCard_TYPE
 * raw_url: Order_RemoveGiftCard_RAW_URL
 * @param cmd -
 */
export const Order_RemoveGiftCard = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/giftcard'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Order_RemoveGiftCard_RAW_URL = function() {
  return '/api/order/giftcard'
}
export const Order_RemoveGiftCard_TYPE = function() {
  return 'delete'
}
export const Order_RemoveGiftCardURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/giftcard'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_SetOrderToWireTransfer
 * url: Order_SetOrderToWireTransferURL
 * method: Order_SetOrderToWireTransfer_TYPE
 * raw_url: Order_SetOrderToWireTransfer_RAW_URL
 * @param cmd -
 */
export const Order_SetOrderToWireTransfer = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/set-wiretransfer'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Order_SetOrderToWireTransfer_RAW_URL = function() {
  return '/api/order/set-wiretransfer'
}
export const Order_SetOrderToWireTransfer_TYPE = function() {
  return 'put'
}
export const Order_SetOrderToWireTransferURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/set-wiretransfer'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_UpdateCustomer
 * url: Order_UpdateCustomerURL
 * method: Order_UpdateCustomer_TYPE
 * raw_url: Order_UpdateCustomer_RAW_URL
 * @param cmd -
 */
export const Order_UpdateCustomer = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/customer'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Order_UpdateCustomer_RAW_URL = function() {
  return '/api/order/customer'
}
export const Order_UpdateCustomer_TYPE = function() {
  return 'put'
}
export const Order_UpdateCustomerURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/customer'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AddReduction
 * url: Order_AddReductionURL
 * method: Order_AddReduction_TYPE
 * raw_url: Order_AddReduction_RAW_URL
 * @param cmd -
 */
export const Order_AddReduction = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/reduction'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_AddReduction_RAW_URL = function() {
  return '/api/order/reduction'
}
export const Order_AddReduction_TYPE = function() {
  return 'post'
}
export const Order_AddReductionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/reduction'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_RemoveReduction
 * url: Order_RemoveReductionURL
 * method: Order_RemoveReduction_TYPE
 * raw_url: Order_RemoveReduction_RAW_URL
 * @param cmd -
 */
export const Order_RemoveReduction = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/reduction'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Order_RemoveReduction_RAW_URL = function() {
  return '/api/order/reduction'
}
export const Order_RemoveReduction_TYPE = function() {
  return 'delete'
}
export const Order_RemoveReductionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/reduction'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_PayPalCreateOrder
 * url: Order_PayPalCreateOrderURL
 * method: Order_PayPalCreateOrder_TYPE
 * raw_url: Order_PayPalCreateOrder_RAW_URL
 * @param cmd -
 */
export const Order_PayPalCreateOrder = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/paypal-create'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_PayPalCreateOrder_RAW_URL = function() {
  return '/api/order/paypal-create'
}
export const Order_PayPalCreateOrder_TYPE = function() {
  return 'post'
}
export const Order_PayPalCreateOrderURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/paypal-create'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_PayPalTransactionComplete
 * url: Order_PayPalTransactionCompleteURL
 * method: Order_PayPalTransactionComplete_TYPE
 * raw_url: Order_PayPalTransactionComplete_RAW_URL
 * @param cmd -
 */
export const Order_PayPalTransactionComplete = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/paypal-transaction'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_PayPalTransactionComplete_RAW_URL = function() {
  return '/api/order/paypal-transaction'
}
export const Order_PayPalTransactionComplete_TYPE = function() {
  return 'post'
}
export const Order_PayPalTransactionCompleteURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/paypal-transaction'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_CloseOrder
 * url: Order_CloseOrderURL
 * method: Order_CloseOrder_TYPE
 * raw_url: Order_CloseOrder_RAW_URL
 * @param cmd -
 */
export const Order_CloseOrder = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/close'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Order_CloseOrder_RAW_URL = function() {
  return '/api/order/close'
}
export const Order_CloseOrder_TYPE = function() {
  return 'put'
}
export const Order_CloseOrderURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/close'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_OptinOptions
 * url: Order_OptinOptionsURL
 * method: Order_OptinOptions_TYPE
 * raw_url: Order_OptinOptions_RAW_URL
 * @param cmd -
 */
export const Order_OptinOptions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/optin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Order_OptinOptions_RAW_URL = function() {
  return '/api/order/optin'
}
export const Order_OptinOptions_TYPE = function() {
  return 'put'
}
export const Order_OptinOptionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/optin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_Reduction
 * url: Order_ReductionURL
 * method: Order_Reduction_TYPE
 * raw_url: Order_Reduction_RAW_URL
 * @param id -
 */
export const Order_Reduction = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/reduction/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_Reduction_RAW_URL = function() {
  return '/api/order/reduction/{id}'
}
export const Order_Reduction_TYPE = function() {
  return 'get'
}
export const Order_ReductionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/reduction/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_ClaimOrder
 * url: Order_ClaimOrderURL
 * method: Order_ClaimOrder_TYPE
 * raw_url: Order_ClaimOrder_RAW_URL
 * @param req -
 */
export const Order_ClaimOrder = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/claim'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['req'] !== undefined) {
    body = parameters['req']
  }
  if (parameters['req'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: req'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Order_ClaimOrder_RAW_URL = function() {
  return '/api/order/claim'
}
export const Order_ClaimOrder_TYPE = function() {
  return 'put'
}
export const Order_ClaimOrderURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/claim'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_ClosedOrdersForUser
 * url: Order_ClosedOrdersForUserURL
 * method: Order_ClosedOrdersForUser_TYPE
 * raw_url: Order_ClosedOrdersForUser_RAW_URL
 * @param page -
 */
export const Order_ClosedOrdersForUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/account-overview/{page}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{page}', `${parameters['page']}`)
  if (parameters['page'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: page'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Order_ClosedOrdersForUser_RAW_URL = function() {
  return '/api/order/account-overview/{page}'
}
export const Order_ClosedOrdersForUser_TYPE = function() {
  return 'get'
}
export const Order_ClosedOrdersForUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/account-overview/{page}'
  path = path.replace('{page}', `${parameters['page']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AmazonPayCreateCheckoutSession
 * url: Order_AmazonPayCreateCheckoutSessionURL
 * method: Order_AmazonPayCreateCheckoutSession_TYPE
 * raw_url: Order_AmazonPayCreateCheckoutSession_RAW_URL
 * @param cmd -
 */
export const Order_AmazonPayCreateCheckoutSession = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/amazonpay-create'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_AmazonPayCreateCheckoutSession_RAW_URL = function() {
  return '/api/order/amazonpay-create'
}
export const Order_AmazonPayCreateCheckoutSession_TYPE = function() {
  return 'post'
}
export const Order_AmazonPayCreateCheckoutSessionURL = function(
  parameters = {},
) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/amazonpay-create'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AmazonPayProcessCheckoutSession
 * url: Order_AmazonPayProcessCheckoutSessionURL
 * method: Order_AmazonPayProcessCheckoutSession_TYPE
 * raw_url: Order_AmazonPayProcessCheckoutSession_RAW_URL
 * @param cmd -
 */
export const Order_AmazonPayProcessCheckoutSession = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/amazonpay-authorized'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_AmazonPayProcessCheckoutSession_RAW_URL = function() {
  return '/api/order/amazonpay-authorized'
}
export const Order_AmazonPayProcessCheckoutSession_TYPE = function() {
  return 'post'
}
export const Order_AmazonPayProcessCheckoutSessionURL = function(
  parameters = {},
) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/amazonpay-authorized'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AmazonPayCreateRedirect
 * url: Order_AmazonPayCreateRedirectURL
 * method: Order_AmazonPayCreateRedirect_TYPE
 * raw_url: Order_AmazonPayCreateRedirect_RAW_URL
 * @param cmd -
 */
export const Order_AmazonPayCreateRedirect = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/amazonpay-createredirect'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_AmazonPayCreateRedirect_RAW_URL = function() {
  return '/api/order/amazonpay-createredirect'
}
export const Order_AmazonPayCreateRedirect_TYPE = function() {
  return 'post'
}
export const Order_AmazonPayCreateRedirectURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/amazonpay-createredirect'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Order_AmazonPayCompletePayment
 * url: Order_AmazonPayCompletePaymentURL
 * method: Order_AmazonPayCompletePayment_TYPE
 * raw_url: Order_AmazonPayCompletePayment_RAW_URL
 * @param cmd -
 */
export const Order_AmazonPayCompletePayment = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/amazonpay-complete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Order_AmazonPayCompletePayment_RAW_URL = function() {
  return '/api/order/amazonpay-complete'
}
export const Order_AmazonPayCompletePayment_TYPE = function() {
  return 'post'
}
export const Order_AmazonPayCompletePaymentURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/amazonpay-complete'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Voucher_RetriveVoucherCustomer
 * url: Voucher_RetriveVoucherCustomerURL
 * method: Voucher_RetriveVoucherCustomer_TYPE
 * raw_url: Voucher_RetriveVoucherCustomer_RAW_URL
 * @param id -
 * @param key -
 * @param idVoucher -
 */
export const Voucher_RetriveVoucherCustomer = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/voucher/{id}/{key}/{idVoucher}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{idVoucher}', `${parameters['idVoucher']}`)
  if (parameters['idVoucher'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: idVoucher'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Voucher_RetriveVoucherCustomer_RAW_URL = function() {
  return '/api/voucher/{id}/{key}/{idVoucher}'
}
export const Voucher_RetriveVoucherCustomer_TYPE = function() {
  return 'get'
}
export const Voucher_RetriveVoucherCustomerURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/voucher/{id}/{key}/{idVoucher}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{idVoucher}', `${parameters['idVoucher']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Voucher_UpdateVoucherCustomer
 * url: Voucher_UpdateVoucherCustomerURL
 * method: Voucher_UpdateVoucherCustomer_TYPE
 * raw_url: Voucher_UpdateVoucherCustomer_RAW_URL
 * @param id -
 * @param key -
 * @param idVoucher -
 * @param customer -
 */
export const Voucher_UpdateVoucherCustomer = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/voucher/{id}/{key}/{idVoucher}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{idVoucher}', `${parameters['idVoucher']}`)
  if (parameters['idVoucher'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: idVoucher'))
  }
  if (parameters['customer'] !== undefined) {
    body = parameters['customer']
  }
  if (parameters['customer'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: customer'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const Voucher_UpdateVoucherCustomer_RAW_URL = function() {
  return '/api/voucher/{id}/{key}/{idVoucher}'
}
export const Voucher_UpdateVoucherCustomer_TYPE = function() {
  return 'put'
}
export const Voucher_UpdateVoucherCustomerURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/voucher/{id}/{key}/{idVoucher}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{idVoucher}', `${parameters['idVoucher']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: Voucher_DownloadVoucher
 * url: Voucher_DownloadVoucherURL
 * method: Voucher_DownloadVoucher_TYPE
 * raw_url: Voucher_DownloadVoucher_RAW_URL
 * @param id -
 * @param key -
 * @param idVoucher -
 */
export const Voucher_DownloadVoucher = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/voucher/download/{id}/{key}/{idVoucher}.pdf'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{idVoucher}', `${parameters['idVoucher']}`)
  if (parameters['idVoucher'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: idVoucher'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Voucher_DownloadVoucher_RAW_URL = function() {
  return '/api/voucher/download/{id}/{key}/{idVoucher}.pdf'
}
export const Voucher_DownloadVoucher_TYPE = function() {
  return 'get'
}
export const Voucher_DownloadVoucherURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/voucher/download/{id}/{key}/{idVoucher}.pdf'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{idVoucher}', `${parameters['idVoucher']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
/**
 *
 * request: WebHooks_PayPal
 * url: WebHooks_PayPalURL
 * method: WebHooks_PayPal_TYPE
 * raw_url: WebHooks_PayPal_RAW_URL
 * @param hook -
 */
export const WebHooks_PayPal = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/webhooks/paypal'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hook'] !== undefined) {
    body = parameters['hook']
  }
  if (parameters['hook'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hook'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const WebHooks_PayPal_RAW_URL = function() {
  return '/api/webhooks/paypal'
}
export const WebHooks_PayPal_TYPE = function() {
  return 'post'
}
export const WebHooks_PayPalURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/webhooks/paypal'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}

/**
 *
 * request: Order_AffiliateSummary
 * url: Order_AffiliateSummaryURL
 * method: Order_AffiliateSummary_TYPE
 * raw_url: Order_AffiliateSummary_RAW_URL
 * @param id -
 * @param key -
 */
export const Order_AffiliateSummary = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/order/summary/{id}/{key}'
  let body
  let queryParameters = {}
  let form = {}

  path = path.replace('{id}', `${parameters['id']}`)

  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }

  path = path.replace('{key}', `${parameters['key']}`)

  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }

  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }

  return request('get', domain + path, body, queryParameters, form, config)
}

export const Order_AffiliateSummary_RAW_URL = function() {
  return '/api/order/summary/{id}/{key}'
}
export const Order_AffiliateSummary_TYPE = function() {
  return 'get'
}
export const Order_AffiliateSummaryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/order/summary/{id}/{key}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)

  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }

  let keys = Object.keys(queryParameters)
  return (
    domain +
    path +
    (keys.length > 0
      ? '?' +
        keys
          .map(key => key + '=' + encodeURIComponent(queryParameters[key]))
          .join('&')
      : '')
  )
}
